import React from "react";
import { BsTrophyFill } from "react-icons/bs";
import { SiAntdesign } from "react-icons/si";
import { BiCodeAlt } from "react-icons/bi";
import { IoMdPeople } from "react-icons/io";

export const funFacts = [
  { icon: <BsTrophyFill />, des: "Best Senior Project EagleX" },
  { icon: <SiAntdesign />, des: "3+ Research Papers Published" },
  { icon: <BiCodeAlt />, des: "Finalist Eagle Hacks Hackathon" },
  { icon: <IoMdPeople />, des: "FGCU Engineering Ambassador" },
];
